// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_s5-5";
export var filledCircle = "_s5-4";
export var historyEntry = "_s5-3";
export var messageSideLeft = "_s5-1";
export var messageSideRight = "_s5-2";
export var orderTrackingCarouselWrapper = "_s5-6";
export var orderTrackingInfoContainer = "_s5-0";